import {
  fabuildingsclassicregular,
  facircleplusclassicregular,
  faaddressbookclassicregular,
  fafilechartcolumnclassicregular,
  fafilecirclecheckclassicregular,
  fafileinvoicedollarclassicregular,
  fafilesignatureclassicregular,
  fafileclassicregular,
  fagearclassicregular,
  fahouseclassicregular,
  famapclassicregular,
  fatablelistclassicregular
} from '@grc/ui-package';
import {
  lanesAndLogisticsPlan,
  shipmentManagement
} from '../../../../common/constants/url-constants';

export const MenuItems = [
  {
    id: 1,
    parentId: 0,
    text: 'Home',
    path: '/home',
    icon: fahouseclassicregular,
    expanded: false
  },
  {
    id: 2,
    parentId: 0,
    text: 'Orders / Quotations',
    path: undefined,
    icon: fafilecirclecheckclassicregular,
    expanded: false
  },
  {
    id: 21,
    parentId: 2,
    text: 'Create Order',
    path: '/ordersquotations/createorder',
    icon: facircleplusclassicregular,
    expanded: false
  },
  {
    id: 22,
    parentId: 2,
    text: 'Create Quote',
    path: '/ordersquotations/createquote',
    icon: fafilesignatureclassicregular,
    expanded: false
  },
  {
    id: 23,
    parentId: 2,
    text: 'Quote Management',
    path: '/ordersquotations/quotemanagement',
    icon: fatablelistclassicregular,
    expanded: false
  },
  {
    id: 3,
    parentId: 0,
    text: 'Shipments',
    path: shipmentManagement,
    icon: fabuildingsclassicregular,
    expanded: false
  },
  {
    id: 4,
    parentId: 0,
    text: 'Support Contacts',
    path: '/supportcontacts',
    icon: faaddressbookclassicregular,
    expanded: false
  },
  {
    id: 5,
    parentId: 0,
    text: 'Releases',
    path: '/releases',
    icon: fafilecirclecheckclassicregular,
    expanded: false
  },
  {
    id: 6,
    parentId: 0,
    text: 'Documents',
    path: '/documents',
    icon: fafilechartcolumnclassicregular,
    expanded: false
  },
  {
    id: 7,
    parentId: 0,
    text: 'Lanes & Logistics Plan',
    path: lanesAndLogisticsPlan,
    icon: famapclassicregular,
    expanded: false
  },
  {
    id: 8,
    parentId: 0,
    text: 'Reports',
    path: '/reports',
    icon: fafilechartcolumnclassicregular,
    expanded: false
  },
  {
    id: 9,
    parentId: 0,
    text: 'Invoices',
    path: '/invoices',
    icon: fafileinvoicedollarclassicregular,
    expanded: false
  },
  {
    id: 10,
    parentId: 0,
    text: 'Claims',
    path: '/claims',
    icon: fafilecirclecheckclassicregular,
    expanded: false
  },
  {
    id: 11,
    parentId: 0,
    text: 'Tickets',
    path: '/tickets',
    icon: fagearclassicregular,
    expanded: false
  },
  {
    id: 12,
    parentId: 0,
    text: 'FTP Users',
    path: '/ftpusers',
    icon: fafileclassicregular,
    expanded: false
  }
];

export interface ProductType {
  id: number;
  text: string;
  parentId: number;
  items?: ProductType[];
  icon?: any;
  expanded?: boolean;
  image?: string;
  price?: number;
}

export function getMenuItemTextByPath(path: string): string {
  const findMenuItem = (items: any[], path: string): any => {
    for (const item of items) {
      if (item.path === path) {
        return item;
      }
      if (item.items) {
        const found = findMenuItem(item.items, path);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  const menuItem = findMenuItem(MenuItems, path);
  if (menuItem) {
    if (menuItem.parentId !== 0) {
      const parentItem = MenuItems.find(item => item.id === menuItem.parentId);
      return parentItem ? parentItem.text : menuItem.text;
    }
    return menuItem.text;
  }
  return '';
}

export function getMenuItemNameWithPath(path: string): string {
  const findMenuItem = (items: any[], path: string): any => {
    let foundItem = null;
    for (const item of items) {
      if (item.path === path) {
        if (!foundItem || item.parentId !== 0) {
          foundItem = item;
        }
      }
      if (item.items) {
        const found = findMenuItem(item.items, path);
        if (found) {
          if (!foundItem || found.parentId !== 0) {
            foundItem = found;
          }
        }
      }
    }
    return foundItem;
  };

  const menuItem = findMenuItem(MenuItems, path);
  return menuItem ? menuItem.text : '';
}
